import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";
import { User, Building2 } from "lucide-react";

/**
 * Contact-related communications fields: contact_id, company_id, and the
 * denormalized display fields company_name, contact_name.
 */
export const contactCommunicationsFields = defineFieldConfigMap({
  // FIELD: contact_id
  contact_id: {
    type: "client-select",
    label: "Contact",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "contacts",
      referencedColumn: "id",
      constraintName: "communications_contact_id_fkey",
      onDelete: "CASCADE",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    placeholder: "Search for contact...",
    clientSelectConfig: {
      showModal: true,
      limit: 20,
    },
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "client-select",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    icon: "User",
    mobileDetailSectionId: "contact",
    groupable: true,
    // Role-based access control
    allowedRoles: ["wtc_employee", "wtc_admin"],
    graphqlSelector: "contact_id",
    savedViewMembership: [
      "all-communications",
      "recent-communications",
      "type-email",
      "type-note",
      "type-call",
      "type-meeting",
      "outbound-communications",
      "inbound-communications",
    ],
  },
  // FIELD: company_id
  company_id: {
    type: "text",
    label: "Company",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "companies",
      referencedColumn: "id",
      constraintName: "communications_company_id_fkey",
      onDelete: "SET NULL",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    placeholder: "Company ID...",
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    filterType: "company-select",
    width: 150,
    minWidth: 120,
    maxWidth: 200,
    icon: "Building2",
    mobileDetailSectionId: "contact",
    // Role-based access control
    allowedRoles: ["wtc_employee", "wtc_admin"],
  },
  // FIELD: company_name
  company_name: {
    type: "text",
    label: "Company Name",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    excludeFromApi: true,
    filterType: "contains",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    icon: "Building2",
    mobileDetailSectionId: "contact",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    showOnCard: true,
    cardSpan: 3,
  },
  // FIELD: contact_name
  contact_name: {
    type: "text",
    label: "Contact Name",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    excludeFromApi: true,
    filterType: "contains",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    icon: "User",
    mobileDetailSectionId: "contact",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    showOnCard: true,
    cardSpan: 3,
  },
});
